import { useEffect, useRef, useState } from 'react';

/**
 * Devuelve `visible: true` cuando el usuario hace scroll hacia arriba (o esta
 * cerca del top), `false` cuando hace scroll hacia abajo. Estilo Twitter/X.
 *
 * @param {object} opts
 * @param {number} opts.threshold  Pixeles minimos de delta para reaccionar (default 6)
 * @param {number} opts.topOffset  Si scrollY < topOffset, siempre visible (default 80)
 * @param {boolean} opts.disabled  Si true, mantiene visible y no escucha scroll
 */
export default function useScrollDirection({
  threshold = 6,
  topOffset = 80,
  disabled = false,
} = {}) {
  const [visible, setVisible] = useState(true);
  const lastScrollRef = useRef(0);

  useEffect(() => {
    if (disabled) {
      setVisible(true);
      return undefined;
    }
    const onScroll = () => {
      const current = window.scrollY;
      const delta = current - lastScrollRef.current;

      if (current < topOffset) {
        setVisible(true);
      } else if (delta > threshold) {
        setVisible(false);
      } else if (delta < -threshold) {
        setVisible(true);
      }
      lastScrollRef.current = current;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold, topOffset, disabled]);

  return visible;
}
